<template>
  <div class="student-table">
    <div class="btnview">
      <el-button
        class="addclass"
        size="small"
        type="primary"
        plain
        @click="openDialog"
        >选择学员</el-button
      >
    </div>

    <el-dialog
      title="选择试听学员"
      :visible.sync="addClassDialogVisible"
      width="80%"
      top="10vh"
      append-to-body
    >
      <el-form
        :inline="true"
        class="form-style"
        size="small"
        v-model="ruleForm"
      >
        <el-form-item label="学员姓名:">
          <el-input
            v-model="ruleForm.nickname"
            placeholder="请输入学员姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="家长手机号:">
          <el-input
            v-model="ruleForm.phone_num"
            placeholder="请输入家长手机号"
          ></el-input>
        </el-form-item>

        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="timeScope"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>

      <div class="table-style">
        <el-table
          size="small"
          :data="tableData"
          highlight-current-row
          @current-change="handleCurrentClass"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            width="150"
            align="center"
            prop="name"
            label="账号"
          ></el-table-column>

          <el-table-column
            width="100"
            align="center"
            prop="nickname"
            label="姓名"
          ></el-table-column>
          <el-table-column
            width="50"
            align="center"
            prop="sex"
            label="性别"
          ></el-table-column>

          <el-table-column
            width="150"
            align="center"
            prop="school_name"
            label="学校名称"
          ></el-table-column>
          <el-table-column
            width="150"
            align="center"
            prop="gradeStr"
            label="在校年级"
          ></el-table-column>

          <el-table-column align="center" label="所在班级" width="250">
            <template slot-scope="scope">
              <div
                v-for="item in scope.row.curriculum_class_list"
                :key="item.id"
              >
                <span>{{ item.name }}</span> <br />
              </div>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="联系电话">
            <template slot-scope="scope">
              <span>{{ scope.row.parent_a }}</span>
              <span>{{ scope.row.parent_a_phone_num }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="家长微信">
            <template slot-scope="scope">
              <span>{{ scope.row.parent_b }}</span>
              <span>{{ scope.row.parent_b_phone_num }}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            prop="leaderNickname"
            label="负责人"
          ></el-table-column>

          <el-table-column
            width="150"
            align="center"
            prop="created_time"
            label="录入时间"
          ></el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 30px; text-align: right">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-size="20"
          layout="total,prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quit">取消</el-button>
        <el-button size="small" type="primary" @click="confirmTo"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getStudentListForClassAddStudent } from '@/api/educational'

export default {
  name: 'addStudent',

  data() {
    return {
      addClassDialogVisible: false,
      ruleForm: {
        student_name: '',
        nickname: '',
        phone_num: '',
        start_time: '',
        end_time: '',
      },
      timeScope: [],
      tableData: [],
      chooseStudent: {},

      page_no: '1',
      page_size: '10',
      total: '',
    }
  },

  mounted() {
    this.getStudentListForClassAddStudent()
  },

  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_no = val
      this.getStudentListForClassAddStudent()
    },

    //查询所有学生
    getStudentListForClassAddStudent() {
      getStudentListForClassAddStudent({
        student_name: '', //学员姓名
        classes_name: '', //班级名称
        phone_num: '', //家长手机
        is_classes: '', //有课学员、无可学员
        start_time: '',
        end_time: '',
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询所有学员')
        console.log(res)
        this.tableData = res.student_list
        this.total = res.total
      })
    },

    detailStudent(row) {
      this.$router.push({
        name: 'student-detail',
        query: {
          id: row.id,
        },
      })
    },
    updateStudent(row) {
      this.$router.push({
        name: 'entering-student',
        query: {
          id: row.id,
        },
      })
    },
    deleteStudent(row) {
      console.log(row)
    },
    openDialog() {
      this.addClassDialogVisible = true
    },

    handleCurrentClass(val) {
      console.log(val)
      this.chooseStudent = val
    },
    quit() {
      this.addClassDialogVisible = false
    },
    // 确认导入
    confirmTo() {
      this.$emit('chooseStudent', this.chooseStudent)
      this.quit()
    },
  },
}
</script>

<style lang="scss" scoped>
.student-table {
  .btnview {
    text-align: left;
    .addclass {
      margin-bottom: 20px;
    }
  }
  .reference {
    display: inline-block;
    width: 25px;
    height: 25px;
    margin-left: 10px;
    font-weight: bold;
    text-align: center;
    line-height: 25px;
    background-color: rgba(228, 213, 77, 0.5);
    border-radius: 50%;
  }
}
</style>
